import { ActionTree } from "vuex";
import axios from "@/network/api";
import router from "@/router";
import { UserState } from "@/models/UserState.d.ts";
import { User } from "@/models/User.d.ts";
import { AxiosResponse, AxiosError } from "axios";
import { Language } from "@/models/Language.d.ts";
import { i18n, updateTranslation } from "@/i18n";

//May be think of a better way for the default state
export const actions: ActionTree<UserState, {}> = {
  tryAutoLogin: function({ commit, dispatch }, toPath = "/") {
    const storageToken = localStorage.getItem("access_token");
    const stateToken = (this.state as any).User.accessToken;
    // console.log('storageToken', storageToken);
    // console.log('stateToken', stateToken);
    if (!storageToken && !stateToken) {
      // console.log('logout from autoLogin');
      this.dispatch("logout", toPath);
      return;
    } else {
      if (!stateToken) {
        commit("setAccessToken", {
          accessToken: storageToken
        });
      }
      dispatch("getUserData");
      dispatch("fetchUserEvent");
    }
  },
  login(
    { commit },
    authData: { email: string; password: string; eventCode: string; to: "/" }
  ) {
    axios
      .post(
        "/auth/login",
        {
          email: authData.email,
          password: authData.password,
          eventCode: authData.eventCode
        },
        {
          headers: {
            "X-Localization": i18n.locale
          }
        }
      )
      .then((res: AxiosResponse) => {
        localStorage.setItem("access_token", res.data.access_token);
        commit("setAccessToken", res.data.access_token);
        // Dispatch getUserData action on successful
        this.dispatch("getUserData");
        this.dispatch("fetchUserEvent");
        router.push(authData.to);
      })
      .catch((error: AxiosError) => {
        commit("setError", error);
      });
  },
  register(
    { commit },
    authData: {
      email: string;
      firstName: string;
      lastName: string;
      eventCode: string;
    }
  ) {
    return axios
      .post(
        "/register",
        {
          email: authData.email,
          firstName: authData.firstName,
          lastName: authData.lastName,
          eventCode: authData.eventCode
        },
        {
          headers: {
            "X-Localization": i18n.locale
          }
        }
      )
      .then((res: AxiosResponse) => {
        return res;
      })
      .catch((error: AxiosError) => {
        commit("setError", error);
      });
  },
  getUserData({ commit }) {
    return axios
      .get("/auth/user", {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
      .then((res: AxiosResponse) => {
        const user: User = res.data.data;
        commit("setUserData", user);
        updateTranslation(user.language);
        if (user.forceReset) {
          router.push("/change_password");
        }
      });
  },
  getTerms({ commit }) {
    axios.get("/terms").then((response: AxiosResponse) => {
      commit("setTerms", response.data.data.terms);
    });
  },
  changeLanguage({ commit }, language: Language) {
    axios
      .post(
        "/auth/language",
        { language: language.id },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token")
          }
        }
      )
      .then(() => {
        commit("setUserLanguage", language);
      });
  },
  logout({ commit }, fromPath = "/") {
    // console.log('Perform Logout');
    localStorage.removeItem("access_token");
    commit("resetEventState");
    commit("resetUserState");
    if (router.currentRoute.path !== "/login") {
      router.push({ name: "Login", params: { redirectTo: fromPath } });
    }
  },
  setPlayingVideoState({ commit }, isPlaying: boolean) {
    commit("setPlayingVideoState", isPlaying);
  }
};
